import React from 'react'
import { FiSend, FiMapPin, FiPhone, FiMail } from "react-icons/fi";
import "../Footer.css";
import logo from '../../assets/visionvotelogo-2.png';
import { Link } from "react-router-dom";

const Footer
    = () => {
        return (
            <footer className="footer">
                <div className="footer-container">

                    {/* BRAND SECTION */}
                    <div className="footer-brand">
                        <div className="footer-logo">
                            <img src={logo} alt="Visionvote Technologies" />
                            <div className="brand-text">
                                <h3>VISIONVOTE TECHNOLOGIES</h3>
                                <span className="brand-tag">Private Limited</span>
                            </div>

                        </div>

                        <p>
                            VisionVote Technologies Private Limited is a modern software startup delivering innovative web applications, mobile apps, AI-powered solutions, cloud services, and enterprise software that help businesses accelerate growth in the digital era.
                        </p>
                    </div>

                    {/* LINKS */}
                    <div className="footer-col">
                        <h4>Company</h4>
                        <a href="/">Home</a>
                        <a href="/company">About Us</a>
                        <a href="/industries">Industries</a>
                        <a href="/contact">Contact Us</a>
                    </div>

                    <div className="footer-col">
                        <h4>Services</h4>
                        <a href="/services">Custom Software Development</a>
                        <a href="/services">Cloud Solutions</a>
                        <a href="/services">Technology Consulting</a>
                        <a href="/services">AI & Automation</a>
                        <a href="/services">Support & Maintenance</a>
                    </div>

                    <div className="footer-col">
                        <h4>Contact Us</h4>

                        <div className="contact-item">
                            <FiMapPin />
                            <span>H No-39a, Ramnagar Road, West Tripura, Ramnagar (west Tripura), Sadar, Tripura, India, 799002</span>
                        </div>

                        <div className="contact-item">
                            <FiPhone />
                            <span>03816780017</span>
                        </div>

                        <div className="contact-item">
                            <FiMail />
                            <span>research@techvisionvote.in</span>
                        </div>
                    </div>



                </div>

                {/* BOTTOM BAR */}
                <div className="footer-bottom">
                    <p>© {new Date().getFullYear()} Visionvote Technologies Private Limited. All rights reserved.</p>
                </div>
            </footer>
        )
    }

export default Footer
